import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui-react';

import errorImage from '../../assets/Images/error48.png';
import successImage from '../../assets/Images/check48.png';
import showResultsImage from '../../assets/Images/showresults.jpg';

import { ErrorDetails} from './ErrorDetails'
import { ErrorResult } from '../../shared/interfaces'
import styles from './Errors.module.css';

export interface IErrorProps {
  errorResult:ErrorResult|null
}

export const Errors = ({
  errorResult=null
}:IErrorProps) =>{
  const { t } = useTranslation();
  
  if (errorResult===null) {
    return null;
  }
  else {
    let err
    if (errorResult.No ===99999) {
      err = <div className={styles.centerChildren}><img src={successImage} alt={t("images.success")} style={{float:"left"}}/>
            <span><strong>{t(errorResult.Message)}</strong></span></div> 
    } else
    {
      err=<div>
        <div className={styles.centerChildren}><img src={errorImage} alt={t("images.error")} style={{float:"left"}}/>
          <span><strong>{t("errors." +errorResult.No.toString())}</strong></span>
        </div>
        { errorResult.AnalysisErrors && errorResult.AnalysisErrors.length>0 ?  <ErrorDetails details={ errorResult.AnalysisErrors} />:null} 
      </div>   
    }
    const content = <Grid>
      <Grid.Row>
        <Grid.Column width="13">
          {err}
        </Grid.Column>
        <Grid.Column width="3">
          <img src={showResultsImage} alt={t("images.results")}/>
        </Grid.Column>
      </Grid.Row>
      
    </Grid>
    return content;
  }
}